"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authSuiteInAppPurchaseService = exports.AuthSuiteInAppPurchaseService = void 0;
var in_app_purchase_service_1 = require("./in-app-purchase.service");
Object.defineProperty(exports, "AuthSuiteInAppPurchaseService", { enumerable: true, get: function () { return in_app_purchase_service_1.AuthSuiteInAppPurchaseService; } });
Object.defineProperty(exports, "authSuiteInAppPurchaseService", { enumerable: true, get: function () { return in_app_purchase_service_1.authSuiteInAppPurchaseService; } });
